import { defineStore } from 'pinia';
import storeEuser from './store-euser';
import storeCuser from './store-cuser';
import accountManager from '../utils/account';

const getStoreOption = (key, loginTypeNew, defaultValue = () => null) => {
  const store = {
    4: storeEuser(),
    6: storeCuser(),
  }[loginTypeNew];
  return store?.[key] || defaultValue;
};

export default defineStore('account', {
  state: () => ({
    loginTypeNew: 4,
  }),
  getters: {
    userLoginTypes: () => ({
      cuser: 6,
      euser: 4,
    }),
    token: (state) => getStoreOption('token', state.loginTypeNew, ''),
    info: (state) => getStoreOption('info', state.loginTypeNew, {}),
    isGetInfo: (state) => getStoreOption('isGetInfo', state.loginTypeNew, false),
    permissionList: (state) => getStoreOption('permissionList', state.loginTypeNew, []),
    accountId: (state) => getStoreOption('accountId', state.loginTypeNew, ''),
    userName: (state) => getStoreOption('userName', state.loginTypeNew, ''),
    isLogin: (state) => getStoreOption('isLogin', state.loginTypeNew, false),
    userRoleConfigId: (state) => getStoreOption('userRoleConfigId', state.loginTypeNew, ''),
    // defaultConfigId: (state) => getStoreOption('defaultConfigId', state.loginType, ''),
  },
  actions: {
    async Login(data) {
      this.setLoginType(data.loginTypeNew || accountManager.getLoginType());
      return await getStoreOption('Login', this.loginTypeNew)(data);
    },
    async GetUserInfo() {
      return await getStoreOption('GetUserInfo', this.loginTypeNew)();
    },
    setUserInfo(userInfo) {
      getStoreOption('setUserInfo', this.loginTypeNew)(userInfo);
    },
    async Logout() {
      return await getStoreOption('Logout', this.loginTypeNew)();
    },
    async reset() {
      return await getStoreOption('reset', this.loginTypeNew)();
    },
    resetToken() {
      getStoreOption('resetToken', this.loginTypeNew)();
    },
    resetAccountId() {
      getStoreOption('resetAccountId', this.loginTypeNew)();
    },
    setLoginType(loginType) {
      this.loginTypeNew = loginType;
      accountManager.setLoginType(loginType);
    },
  },
});
